import type { FlowPublishStateForDetail } from './use-flow-publish-state-for-flow-detail';

export function slotListInfoTitleKeyFromPublishState(
  publishState: FlowPublishStateForDetail,
): 'titleInitialPublish' | 'titleRepublish' | 'titleUpToDate' {
  if (publishState.isUpToDate) return 'titleUpToDate';
  if (publishState.needsInitialPublish) return 'titleInitialPublish';
  return 'titleRepublish';
}
